import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import {
	EXTRA_SCREEN,
	GAME_SCREEN,
	HINTS_SCREEN,
	LOGIN_SCREEN,
	LOGOS_SCREEN,
	MAIN_SCREEN,
	PLAY_SCREEN,
	RANKING_SCREEN,
	SETTINGS_SCREEN,
	STATISTICS_SCREEN
} from '../ducks/duck-screen'
import LOGIN_EMAIL_ACTIONS from '../constants/LOGIN_EMAIL_ACTIONS'
import LoadingScreen from "./loading-screen/loading-screen";
import LogoQuizAppBarContainer from "./logo-quiz-app-bar/logo-quiz-app-bar-container";
import MainScreenContainer from "./main-screen/main-screen-container";
import PlayScreenContainer from "./play-screen/play-screen-container";
import ExtraLevelsScreenContainer from "./extra-levels-screen/extra-levels-screen-container";
import SettingsScreenContainer from "./settings-screen/settings-screen-container";
import LogosScreenContainer from "./logos-screen/logos-screen-container";
import GameScreenContainer from "./game-screen/game-screen-container";
import LoginScreenContainer from "./login-screen/login-screen-container";
import StatsScreenContainer from "./stats-screen/stats-screen-container";
import LoginEmailScreen from "./login-email-screen/login-email-screen";
import RankingScreenContainer from "./ranking-screen/ranking-screen-container";

import BaseModal from './modals/error-modal'
import UnlockLevelModalContainer from './modals/unlock/unlock-level-modal-container'
import UnlockExtraLevelModal from './modals/unlock/unlock-extra-level-modal'
import ConfirmModalContainer from './modals/confirm-modal-container'
import HintsModalContainer from './modals/hints/hints-modal-container'
import WheelModalContainer from './modals/wheel/wheel-modal-container'
import Toast from './toasts/toast-container'
import {
	TYPE_AVATAR_CHANGE,
	TYPE_CONFIRM_DELETE,
	TYPE_CONFIRM_RESET_DATABASE,
	TYPE_CONFIRM_RESET_PASSWORD,
	TYPE_ERROR,
	TYPE_EXTRA_UNLOCK_LEVEL,
	TYPE_HINTS,
	TYPE_INFO,
	TYPE_UNLOCK_LEVEL,
	TYPE_WHEEL
} from "../helpers/modal-builder";
import ErrorBoundary from "./error-boundary";
import AnimationWrapper from "./animation-wrapper/animation-wrapper";

const styles = theme => ({
	phone: {
		margin: "auto",
		border: '16px black solid',
		borderTopWidth: '60px',
		borderBottomWidth: '60px',
		borderRadius: '36px',
		width: "600px",
		height: "96vh",
		minHeight: "500px",
		maxHeight: "1025px",
		/* bo glosnik i guzik sie chowa */
		overflow: "unset",
		position: "absolute",
		left: 0,
		right: 0,
		bottom: 0,
		top: 0,
		"& img": {
			"user-drag": "none",
			"user-select": "none",
			"-webkit-tap-highlight-color":  "rgba(255, 255, 255, 0)",
		},
	},
	contentContainer: {
		overflowY: 'hidden',
		overflowX: 'hidden',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	screenContainer: {
		"flex": 1,
		"minHeight": 0,
		"display": "flex",
		"flex-flow": "column",
		'overflow-y': "auto",
		'overflow-x': "hidden",
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
		height: '100%',
	},
	"@media (max-width: 768px)": {
		// contentContainer:{
		// 	height: '100vh',
		// },
		phone: {
			margin: 0,
			border: 0,
			height: "100%",
			width: "100%",
			maxHeight: 'unset',
			borderRadius: 0,
		}
	},
	"@media (min-width: 769px)": {
		phoneSpeaker:{
			width: '100px',
			height: '5px',
			position: 'absolute',
			top: '-30px',
			left: '50%',
			zIndex: 10,
			transform: 'translate(-50%, -50%)',
			background: '#444',
			borderRadius: '10px',
		},
		phoneButton:{
			width: '35px',
			height: '35px',
			position: 'absolute',
			left: '50%',
			bottom: '-65px',
			transform: 'translate(-50%, -50%)',
			background: '#444',
			borderRadius: '50%',
		},
	}
});

class Phone extends React.Component {
	state = {
		logoScreenInvokedUnlockFunction: false,
	};

	unlockInvocation = () => {
		this.setState({logoScreenInvokedUnlockFunction: true})
	};

	componentDidUpdate(prevProps, prevState){
		if(prevState.logoScreenInvokedUnlockFunction && prevProps.screen === LOGOS_SCREEN && this.props.screen === PLAY_SCREEN){
			this.setState({logoScreenInvokedUnlockFunction: false})
		}
	}

	renderScreenSwitch = ({ screen, push }) => {
		let childProps;
		switch (screen) {
			case PLAY_SCREEN:
				childProps = { push };
				return <PlayScreenContainer {...childProps} />;
			case LOGOS_SCREEN:
				childProps = { push };
				return <LogosScreenContainer {...childProps}
				                             unlockInvocation={this.unlockInvocation}
				                             alreadyInvoked={this.state.logoScreenInvokedUnlockFunction}/>;
			case GAME_SCREEN:
				childProps = { push };
				return <GameScreenContainer {...childProps} />;
			case SETTINGS_SCREEN:
				childProps = { push };
				return <SettingsScreenContainer {...childProps} />;
			case STATISTICS_SCREEN:
				return <StatsScreenContainer/>;
			case EXTRA_SCREEN:
				childProps = { push };
				return <ExtraLevelsScreenContainer {...childProps} />;
			case HINTS_SCREEN:
				return <div onClick={() => push(MAIN_SCREEN)}>hints</div>;
			case RANKING_SCREEN:
				childProps = { push };
				return <RankingScreenContainer {...childProps}/>;
			case LOGIN_SCREEN:
				childProps = { push };
				return <LoginScreenContainer {...childProps}/>;
			case LOGIN_EMAIL_ACTIONS.LOGIN/* || LOGIN_EMAIL_ACTIONS.RESET || LOGIN_EMAIL_ACTIONS.REGISTER*/:
				childProps = { push };
				return <LoginEmailScreen {...childProps}/>;
			default:
				return <MainScreenContainer push={push} />;
		}
	};


	getFirstLoadingScreenOrFalse = (loadingList, screen) => {
		if(loadingList.length === 0 || screen === MAIN_SCREEN){
			return false
		} else {
			return loadingList.find(loadingScreen => loadingScreen.excludedScreens.indexOf(screen) === -1);
		}
	}

// console.log('loadingList', loadingList);
	getScreen = (props) => {
		const { classes,
			screen,
			goBack,
			loadingList } = props;

		let renderScreen;
		const loadingScreen = this.getFirstLoadingScreenOrFalse(loadingList, screen);
		if (loadingScreen) {
			renderScreen = (
				<Paper className={classes.phone} elevation={4}>
					<div className={classes.phoneSpeaker}/>
					<div className={classes.contentContainer}>
						<LogoQuizAppBarContainer currentScreen={screen} goBack={goBack}/>
						<ErrorBoundary>
							<LoadingScreen text={loadingScreen.loadingMessage}/>
						</ErrorBoundary>
					</div>
					<div className={classes.phoneButton}/>
				</Paper>
			);
		} else if (screen === MAIN_SCREEN) {
			renderScreen = (
				<Paper className={classes.phone} elevation={4}>
					<div className={classes.phoneSpeaker}/>
					<div className={classes.contentContainer}>
						<ErrorBoundary>
							{this.renderScreenSwitch(props)}
						</ErrorBoundary>
					</div>
					<div className={classes.phoneButton}/>
				</Paper>
			);
		} else {
			renderScreen = (
				<Paper className={classes.phone} elevation={4}>
					<div className={classes.phoneSpeaker}/>
					<div className={classes.contentContainer}>
						<ErrorBoundary>
							<LogoQuizAppBarContainer currentScreen={screen} goBack={goBack}/>
							<div className={classes.screenContainer}>
								<AnimationWrapper currentScreen={screen} id={"animation-wrapper"}>
									{this.renderScreenSwitch(props)}
								</AnimationWrapper>
							</div>
						</ErrorBoundary>
					</div>
					<div className={classes.phoneButton}/>
				</Paper>
			)
		}
		return renderScreen
	};

	getModals = (props) => {
		const {
			screen,
			goBack,
			modalList,
			removeModalWindow,
			removeModalWindowAtIndexes } = props;

		const modalsToRemove = [];
		const modalComponents =  modalList.map((modal, index) => {
			if(modal.type === TYPE_ERROR || modal.type === TYPE_INFO){
				return (
					<BaseModal modal={modal} key={`modal-${index}`} removeModalWindow={removeModalWindow}/>
				)
			} else if(modal.type === TYPE_UNLOCK_LEVEL){
				return (
					<UnlockLevelModalContainer
						modal={modal}
						key={`modal-${index}`}
						removeModalWindow={removeModalWindow}
						currentScreen={screen}
						goBack={goBack}/>
				)
			} else if(modal.type === TYPE_EXTRA_UNLOCK_LEVEL){
				return (
					<UnlockExtraLevelModal modal={modal} key={`modal-${index}`} removeModalWindow={removeModalWindow}/>
				)
			} else if(modal.type === TYPE_CONFIRM_RESET_DATABASE || modal.type === TYPE_CONFIRM_DELETE || modal.type === TYPE_CONFIRM_RESET_PASSWORD){
				return (
					<ConfirmModalContainer modal={modal} key={`modal-${index}`} removeModalWindow={removeModalWindow}/>
				)
			} else if(modal.type === TYPE_HINTS){
				return (
					<HintsModalContainer modal={modal} key={`modal-${index}`} removeModalWindow={removeModalWindow}/>
				)
			} else if(modal.type === TYPE_WHEEL){
				return (
					<WheelModalContainer modal={modal} key={`modal-${index}`} removeModalWindow={removeModalWindow}/>
				)
			}
			//Usuwamy jeśli nie pojawił się na dobrym ekranie
			if(modal.screen && modal.screen !== screen){
				modalsToRemove.push(index)
			}
		});

		if(modalsToRemove.length > 0){
			removeModalWindowAtIndexes(modalsToRemove);
		}

		return modalComponents

	};

	getToasts = (props) => {
		return props.toastList.map((toast, index) => {
			return <Toast toast={toast} key={`toast-${index}`}/>
		})
	}

	render(){
		return (
			<div style={{height: "100%"}}>
				{this.getToasts(this.props)}
				{this.getModals(this.props)}
				{this.getScreen(this.props)}
			</div>
		)
	};
}

Phone.propTypes = {
	screen: PropTypes.string.isRequired,
	uid: PropTypes.string.isRequired,

	classes: PropTypes.shape({
		phone: PropTypes.string.isRequired,
		phoneSpeaker: PropTypes.string.isRequired,
		phoneButton: PropTypes.string.isRequired,
	}).isRequired,

	loadingList: PropTypes.array.isRequired,
	modalList: PropTypes.array.isRequired,
	toastList: PropTypes.array.isRequired,

	currentLevel: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	goBack: PropTypes.func.isRequired,
	removeModalWindow: PropTypes.func.isRequired,
	removeModalWindowAtIndexes: PropTypes.func.isRequired,
};

export default withStyles(styles)(Phone);
